
class IMC_COMMON {

    constructor() {
        this.css_info = "font-size: 16px;color:red;";
        this.css = "font-size: 40px;color:#5D9733; text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;text-align:center";

        console.log('%c IMC CORE INIT! ', this.css);
        console.log('%c ******* Loik Maksim Product ****** ', this.css);

    }
     showloading_new() {
        this.showloading();
    }

    expand ($this)
    {
        var ul = jQuery($this).parent().parent();
        if (jQuery(ul).hasClass('c-map__poi-panel_full')) {
            jQuery(ul).removeClass('c-map__poi-panel_full');
        }
        else {
            jQuery(ul).addClass('c-map__poi-panel_full');
        }
    }
    Load_Wrapper  (type)
    {
        console.info('Load Wrapper : Menu ID:' + type );
        this.showloading();
        jQuery.ajax
        ({
            url: "/index.php?option=com_imc_docs&task=DrawWrapper",
            type: "POST",
            dataType: "json",
            data:
                {
                    view: type,
                },

            success: function (res) {
                console.log(res);
                IMC_CORE.hideloading()

                if (res.errors != null) {
                    IMC_CORE.message(res.errors);
                }

                else {
                    if (res.html != null) {
                        jQuery('#tab_ajax_data').html(res.html);
                        jQuery('#imc_core_menu_wrapper a[data-id="' + res.message + '"]').parent().addClass('active');
                    }
                }

            },
            error: function (res) {
                console.log(res);
                IMC_CORE.message('OOPS!!!! CALL 911 Support:admin@imcagro.com.ua');
            },
        })

    }

     showloading () {

        this.hideloading();
        jQuery('body').prepend
        (' <div id="loader-wrapper">' +
            '<div id="loader"></div>' +
            '<div class="loader-section section-left"></div>' +
            '<div class="loader-section section-right"></div>' +
            '</div>');
    }

     hideloading () {
        jQuery('.overlay').remove();
        jQuery('#loader-wrapper').remove();
    }

    snackbar(mes) {
        var x = document.getElementById("snackbar")
        jQuery('#snackbar').html(mes);
        x.className = "show_snack";
        setTimeout(function () {
            x.className = x.className.replace("show_snack", "");
        }, 3000);
    }

    getLayouts (data,callback) {
        jQuery.ajax({
            url: '/index.php?option='+ data.option +'&task=get_layouts',
            data: data,
            type: "POST",
            dataType: 'json',
            success: function(responce) {
                callback(responce)
            },
            error : function(res) {
                IMC_COMMON.hideloading();
                EventBus.$emit('show_toast', {err:'OOPS' ,type:"danger",title:'SRV ERR'});
            }
        });
    }

     message (mes, title = "IMC", params = {}) {
        EventBus.$emit('show_imc_modal',{
            title:title,
            html:mes,
            params : params
        });
    }

     closemes (delay) {
        if (delay == undefined) {
            delay = 2500;
        }
        EventBus.$emit('close_imc_modal',{delay:delay})
    }

    InitDatePick (obj) {
        console.warn('DEPRECATED use Joomla datepicker or init_j_datepicker');
        this.init_j_datepicker();
    }

    init_j_datepicker () {
        try {
            let elements = document.querySelectorAll(".field-calendar");
            for (let i = 0; i < elements.length; i++) {
                JoomlaCalendar.init(elements[i]);
            }
        }
        catch (e) {

        }
    }
}

export default IMC_COMMON;
